export default __webpack_public_path__ + "static/media/logoSmall.84e0a673.svg";